var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrmsLogoIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9103_180719",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8824 0.285156H0.117188V25.7185H27.8824V0.285156Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9103_180719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.882 10.4739V15.5109C27.882 21.1361 23.322 25.6961 17.6968 25.6961H14.7168V21.5161H17.3901C20.4583 21.5161 22.9457 19.0287 22.9457 15.9605V10.0242C22.9457 8.07129 21.9379 6.35351 20.4138 5.36277C20.1342 5.18091 19.8368 5.02351 19.5253 4.89388C18.8679 4.6198 18.1468 4.46869 17.3901 4.46869H15.8216V0.289062H17.7627C18.3642 0.292766 18.9531 0.348693 19.5253 0.452767C19.5268 0.452767 19.5286 0.453137 19.5301 0.453507C19.5416 0.455359 19.5535 0.457581 19.5649 0.459803C24.2979 1.33684 27.882 5.48684 27.882 10.4739Z",
    fill: "#0184FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2013 4.48553C13.2079 3.08553 13.2142 1.68553 13.2209 0.285156C8.85274 0.28849 4.48497 0.291823 0.117188 0.294786V25.7022H8.46237V21.4918H5.05348V4.50516C7.76941 4.49849 10.4853 4.49182 13.2013 4.48516V4.48553Z",
    fill: "#0183FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45711 25.7189C8.16119 24.31 7.86526 22.9011 7.56934 21.4922H8.46193L8.45711 25.7189Z",
    fill: "#123972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5262 0.452767V18.8076H15.8225V14.4417H12.1617V25.7172H8.45801V7.19869H12.1617V11.4324H15.8225V0.289062H17.7636C18.365 0.292766 18.9539 0.348693 19.5262 0.452767Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4139 5.36238C20.1343 5.18053 19.8369 5.02313 19.5254 4.8935C19.5258 4.52201 19.5272 2.85794 19.5276 2.48646C19.5287 1.46979 19.5302 0.524606 19.5302 0.453125C19.5417 0.454977 19.5535 0.457199 19.565 0.459421C19.718 1.10572 19.8617 1.78275 19.9913 2.48979C20.1758 3.49313 20.3132 4.45275 20.4139 5.36238Z",
    fill: "#123972"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrmsLogoIconNew);
export default __webpack_public_path__ + "static/media/hrms-logo-icon-new.7cc00a8f7b9f77d50301cb6cc760a10e.svg";
export { ForwardRef as ReactComponent };